import { Component, OnInit } from '@angular/core';
import { GrievanceDashboardService } from '../grievance-dashboard.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ColDef, ExcelExportParams, GridApi, GridReadyEvent, SizeColumnsToContentStrategy, SizeColumnsToFitGridStrategy, SizeColumnsToFitProvidedWidthStrategy } from 'ag-grid-community';
import { ExcelStyle } from 'ag-grid-community';


@Component({
  selector: 'app-grievance-report',
  templateUrl: './grievance-report.component.html',
  styleUrls: ['./grievance-report.component.scss']
})
export class GrievanceReportComponent implements OnInit {
  reportDetails: any;
  quickFilter: string = '';
  private gridApi!: GridApi<any>;

  constructor(private Service: GrievanceDashboardService, private spinner: NgxSpinnerService) { }
  ngOnInit(): void {
    this.grievanceReport();
  }

  rowData: any[] = [];
  pinnedTopRowData: any[] = [];

  defaultExcelExportParams: ExcelExportParams = {
    exportAsExcelTable: true,
  };




  colDefs: ColDef<any>[] = [
    {
      field: 'cityName', headerName: 'City Name',
      cellStyle: { 'text-align': 'left' },
      headerStyle: { 'text-align': 'center' },
    },
    {
      field: 'campusName', headerName: 'Campus Name',
      cellStyle: { 'text-align': 'left' },
      headerStyle: { 'text-align': 'center' },
    },
    {
      field: 'admNo', headerName: 'Adm No',
      cellStyle: { 'text-align': 'right' },
      headerStyle: { 'text-align': 'center' },
    },
    {
      field: 'name', headerName: 'Name',
      cellStyle: { 'text-align': 'left' },
      headerStyle: { 'text-align': 'center' },
    },

    {
      field: 'parentName', headerName: 'Parent Name',
      cellStyle: { 'text-align': 'left' },
      headerStyle: { 'text-align': 'center' },
    },
    {
      field: 'className', headerName: 'Class',
      cellStyle: { 'text-align': 'left' },
      headerStyle: { 'text-align': 'center' },
    },
    {
      field: 'groupName', headerName: 'Group Name',
      cellStyle: { 'text-align': 'left' },
      headerStyle: { 'text-align': 'center' },
    },
    {
      field: 'courseTrack', headerName: 'Course Track',
      cellStyle: { 'text-align': 'left' },
      headerStyle: { 'text-align': 'center' },
    },
    {
      field: 'grievanceType', headerName: 'Grievance Type',
      cellStyle: { 'text-align': 'left' },
      headerStyle: { 'text-align': 'center' },
    },
    {
      field: 'description', headerName: 'Description',
      cellStyle: { 'text-align': 'left' },
      headerStyle: { 'text-align': 'center' },
    },

    {
      field: 'userType', headerName: 'User Type',
      cellStyle: { 'text-align': 'left' },
      headerStyle: { 'text-align': 'center' },
    },
    {
      field: 'createdOn', headerName: 'Date',
      cellStyle: { 'text-align': 'right' },
      headerStyle: { 'text-align': 'center' },
    },
    {
      field: 'grievanceStatus',
      headerName: 'Status',
      headerStyle: { 'text-align': 'center' },
      cellStyle: { 'display': 'flex', 'justify-content': 'center', 'align-items': 'center' },
      cellRenderer: (params: any) => {
        let color = '';
        let textcolor = '';
        switch (params.value) {
          case 'OPEN':
            color = '#E6F2FF'; // Blue
            textcolor = '#0564B1';
            break;
          case 'RESOLVED':
            color = '#EAFFF3'; // Green
            textcolor = '#039334';
            break;
          case 'IN PROGRESS':
            color = '#FFF3E7'; // Orange
            textcolor = '#FF7E00';
            break;
          case 'ESCALATED':
            color = '#FFF4F1'; // Red
            textcolor = '#FF0000';
            break;
          default:
            color = '#9E9E9E'; // Grey fallback
            textcolor = '#FFFFFF';
        }
        return `
        <button style="
          background-color: ${color};
          color: ${textcolor};
          border: none;
          height:30px;
          display:flex;
          justify-content:center;
          align-items:center;
          border-radius: 2px;
          cursor: default;
          font-size:10px;
          min-width:100px;
          font-weight:600;
        ">
          ${params.value}
        </button>
      `;
      }
    },
    {
      field: 'trackDesc', headerName: 'Resolved Description',
      cellStyle: { 'text-align': 'left' },
      headerStyle: { 'text-align': 'center' },
      valueGetter: (params: any) => {
        return params.data.grievanceStatus === 'RESOLVED' ? params.data.trackDesc : '';
      }
    }
  ]

  // default
  defaultColDef: ColDef = {
    flex: 1,
    sortable: true,
    filter: false,
    menuTabs: [],
    suppressHeaderMenuButton: true,
  };
  autoSizeStrategy:
    | SizeColumnsToFitGridStrategy
    | SizeColumnsToFitProvidedWidthStrategy
    | SizeColumnsToContentStrategy = {
      type: "fitCellContents",
    };


  grievanceReport() {
    this.spinner.show();
    const payrollId = localStorage.getItem('userId')
    this.Service.getGrievanceReport(payrollId).subscribe(
      {
        next: (res: any) => {
          if (!res) {
            this.spinner.hide();
            return
          }
          else {
            const customOrder = ['OPEN', 'IN PROGRESS', 'RESOLVED'];
            res = res.sort((a: any, b: any) => {
              return customOrder.indexOf(a.status) - customOrder.indexOf(b.status);
            });
            this.rowData = res;
            this.reportDetails = res;
            this.spinner.hide();
          }
        },
        error: (err: any) => {
          this.spinner.hide();
        }
      }
    )
  }




  onBtExport() {
    this.gridApi.exportDataAsExcel({
      fileName: 'Grievance_Details',
      sheetName: 'Grievance Details',

    });
    alert("Execl Report genarated Please check the Download List")
  }

  onGridReady(params: GridReadyEvent<any>) {
    this.gridApi = params.api;
    this.gridApi.closeToolPanel();
  }

  onQuickFilterChanged(event: any) {
    this.quickFilter = event.target.value;
  }

}
